import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const copyright = t('footer.copyright');
  return (
    <footer className="bg-dark text-white py-4">
      <div className="container text-center">
        <motion.p 
          className="mb-0"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {copyright}
        </motion.p>
      </div>
    </footer>
  );
};

export default Footer; 